export default "__VITE_ASSET__CfO0jNfH__"